module.exports = __webpack_public_path__ + "img/grid-seven.1d28753d.svg";